import React, { useState } from "react";
import Modal from "aldoo-ra/Modal";
import Button from "aldoo-ra/Button";
import Typography from "aldoo-ra/Typography";
import TextBundle from "aldoo-ra/CMS/text-bundle";
import CMSData from "aldoo-ra/CMS/cms-data";

const CancellationReasonDialog = ({
  isOpen,
  onClose,
  onNext,
  subscription,
}) => {
  const [selectedReason, setSelectedReason] = useState(null);

  // Initialize the texts object inside the component
  const texts = TextBundle({ id: "cancellation_reason_dialog" });

  // Fetch unsubscribe reasons from CMS
  const { data: unsubscribeReasonsData = [] } = CMSData({
    contentType: "UnsubscribeReasons"
  });

  // Get the reasons array from the first (and only) instance
  const reasonsData = unsubscribeReasonsData.length > 0 ? unsubscribeReasonsData[0] : null;
  const reasonsArray = reasonsData?.reasons || [];

  // Generate CANCELLATION_REASONS array from CMS data
  // CMSData converts {key, value} arrays to objects, so we need to handle both formats
  let CANCELLATION_REASONS;

  if (reasonsArray && typeof reasonsArray === 'object' && !Array.isArray(reasonsArray)) {
    // CMSData converted it to object {key: value}, convert back to array
    CANCELLATION_REASONS = Object.entries(reasonsArray).map(([key, value]) => ({
      id: key,
      label: value,
    }));
  } else if (Array.isArray(reasonsArray) && reasonsArray.length > 0) {
    // It's an array, check if items have key/value structure
    if (reasonsArray[0]?.key && reasonsArray[0]?.value !== undefined) {
      CANCELLATION_REASONS = reasonsArray.map((item) => ({
        id: item.key,
        label: item.value,
      }));
    } else {
      // Fallback
      CANCELLATION_REASONS = [
        { id: "price", label: "The price is too high" },
        { id: "technical", label: "I'm having technical difficulties" },
        { id: "product", label: "I don't like the product" },
        { id: "autobill", label: "I don't want to be auto-billed" },
        { id: "no_need", label: "I no longer need it" },
        { id: "other", label: "Other" },
      ];
    }
  } else {
    // Fallback if CMS data is not available
    CANCELLATION_REASONS = [
      { id: "price", label: "The price is too high" },
      { id: "technical", label: "I'm having technical difficulties" },
      { id: "product", label: "I don't like the product" },
      { id: "autobill", label: "I don't want to be auto-billed" },
      { id: "no_need", label: "I no longer need it" },
      { id: "other", label: "Other" },
    ];
  }

  return (
    <Modal
      title={texts?.title || "Cancel Subscription"}
      isOpen={isOpen}
      onClose={onClose}
      variant="aqua_big"
      className="md:max-w-[650px]"
      style={{ zIndex: 800 }}
    >
      <div>
        <Typography variant="info_18" className="text-gray_1 mt-0 mb-4">
          {texts?.subtitle || "Quick question... Please tell us why you'd like to cancel? May be we can help."}
        </Typography>

        <Typography variant="info_18_accent" className="text-text">
          {texts?.option_select || "Select an option"}
        </Typography>

        <div className="space-y-4 mb-8">
          {CANCELLATION_REASONS.map((reason) => (
            <div
              key={reason.id}
              onClick={() => setSelectedReason(reason.id)}
              className="flex items-center justify-between rounded-[24px] shadow-custom_card hover:bg-primary_lt cursor-pointer pr-6 py-4"
            >
              <div className="pl-6">
                <input
                  type="radio"
                  checked={selectedReason === reason.id}
                  onChange={() => setSelectedReason(reason.id)}
                  className="!w-4 !h-4 !min-w-[16px] !max-w-[16px] flex items-center justify-center !p-0"
                />
              </div>

              <Typography variant="info_18" className="my-0">
                {reason.label}
              </Typography>
            </div>
          ))}
        </div>

        {selectedReason && (
          <div className="flex justify-end">
            <Button
              variant="secondary_s"
              onClick={() => onNext(selectedReason)}
              className="min-w-[100px]"
            >
              {texts?.cta_next || "Next"}
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CancellationReasonDialog;
